// extracted by mini-css-extract-plugin
export default {"withBorder":"withBorder__NDZjO","vendorsByCategory":"vendorsByCategory__YTMwN"};